import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { NavToolsProps } from './types/NavTools.types';
import './NavTools.scss';
import NavTool from './NavTool';
import NavToolSearch from './NavToolSearch';
import RenderDelay from '../RenderDelay';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const NavTools = ({
  navToolsOpen,
  languages,
  search,
  metaNavigation,
}: NavToolsProps) => {
  const [activeLang, activeLangSet] = useState<string>();
  const [langIsOpen, langIsOpenSet] = useState<boolean>(false);
  const [searchIsOpen, searchIsOpenSet] = useState<boolean>(false);
  const [searchValue, searchValueSet] = useState<string>('');

  const { sitecoreContext } = useSitecoreContext() as any;

  useEffect(() => {
    const al = languages.find((l) => l.active)?.name;
    if (al) activeLangSet(al);
  }, [languages]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      const dataToPush = getDataToPush();
      console.log(dataToPush)
      if (dataToPush) window?.dataLayer?.push(dataToPush);
    }
  }, []);

  const getDataToPush = () => {
    return sitecoreContext && Object.keys(sitecoreContext).length > 0
      ? {
          pageInfo: {
            pageName: sitecoreContext?.route?.fields['GA Page Name']?.value,
            language: sitecoreContext?.language,
            product_name: sitecoreContext?.route?.displayName,
            template_name: sitecoreContext?.route?.templateName,
          },
        }
      : null;
  };

  const selectLang = useCallback(
    (item: string) => {
      activeLangSet(item);
      langIsOpenSet(false);
    },
    [languages]
  );

  const toolsClass = useMemo(() => {
    return searchIsOpen
      ? 'NavTools__Icons NavTools__Icons--Closed'
      : 'NavTools__Icons';
  }, [searchIsOpen]);

  const mainClass = useMemo(() => {
    return navToolsOpen
      ? 'NavTools__Main'
      : 'NavTools__Main NavTools__Main--Closed';
  }, [navToolsOpen]);

  return (
    <div className="NavTools">
      <RenderDelay shouldRender={true} transitionDuration={300}>
        <div className={mainClass}>
          <RenderDelay shouldRender={true} transitionDuration={300}>
            <NavToolSearch
              search={searchValue}
              searchSet={(v: string) => searchValueSet(v)}
              searchIsOpenSet={() => searchIsOpenSet(!searchIsOpen)}
              searchIsOpen={searchIsOpen}
              {...search}
            />
            <div className={toolsClass}>
              <RenderDelay shouldRender={true} transitionDuration={300}>
                {metaNavigation.map((item, idx) => (
                  <NavTool
                    key={idx}
                    link={item.link}
                    icoClass={
                      item?.icon?.fields?.['Icon Css Class']?.value as
                        | 'search'
                        | 'icon-location'
                        | 'icon-piston'
                        | 'icon-headphone'
                    }
                  />
                ))}
              </RenderDelay>
            </div>
          </RenderDelay>
        </div>

        <div className="NavTools__Lang ga4-click-ui-navbar">
          <div onClick={() => langIsOpenSet(!langIsOpen)}>{activeLang}</div>
          {langIsOpen && (
            <ul>
              {languages.map((item) =>
                item.name !== activeLang ? (
                  <li
                    key={item.name}
                    onClick={() => {
                      location.replace(item.url);
                      selectLang(item.name);
                    }}
                  >
                    <a className='ga4-click-ui-navbar'>{item.name}</a>
                  </li>
                ) : null
              )}
            </ul>
          )}
        </div>
      </RenderDelay>
    </div>
  );
};

export default NavTools;
